import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PhotoBooth from './pages/PhotoBooth';
import './App.css';
import Login from './pages/Login';
import Register from './pages/Register';
import Workspace from './pages/Workspace';
import Frames from './pages/Frames';
import FinalFrame from './pages/FinalFrame';
import FinalOutput from './pages/FinalOutput';
import FinalOutput2 from './pages/FinalOutput2';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<PhotoBooth />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/workspace" element={<Workspace />} />
        <Route path="/frames" element={<Frames />} />
        <Route path="/final-frame" element={<FinalFrame />} />
        <Route path="/final-output/:indukname" element={<FinalOutput />} />
        <Route path="/final-output2/:indukname" element={<FinalOutput2 />} />
      </Routes>
    </div>
  );
}

export default App;
